<style lang="less">
    @import "../../../styles/table.less";
</style>
<template>
    <div class="search">
        <Row>
            <Col>
                <Card>
                    <Row @keydown.enter.native="handleSearch">
                        <Form ref="searchForm" :model="searchForm" inline :label-width="70">
                            <Form-item label="企业名称" prop="compName">
                                <Input type="text" v-model="searchForm.compName" placeholder="请输入企业名称" clearable style="width: 200px"/>
                            </Form-item>
                            <Form-item label="联系人" prop="linkMan">
                                <Input type="text" v-model="searchForm.linkMan" placeholder="请输入联系人" clearable style="width: 200px"/>
                            </Form-item>
                            <Form-item label="电话号码" prop="compTel">
                                <Input type="text" v-model="searchForm.compTel" placeholder="请输入电话号码" clearable style="width: 200px"/>
                            </Form-item>
                            <span v-if="drop">
                                <Form-item label="创建时间">
                                  <DatePicker v-model="selectDate" type="daterange" format="yyyy-MM-dd" clearable split-panels
                                      @on-change="selectDateRange" placeholder="选择起始时间" style="width: 200px"></DatePicker>
                                </Form-item>
                            </span>
                            <Form-item style="margin-left:-35px;" class="br">
                                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                                <Button @click="handleReset">重置</Button>
                                <a class="drop-down" @click="dropDown">{{dropDownContent}}
                                    <Icon :type="dropDownIcon"></Icon>
                                </a>
                            </Form-item>
                        </Form>
                    </Row>
                    <Row class="operation">
                        <Button @click="add" type="primary" icon="md-add">新建企业</Button>
                        <Button @click="delAll" icon="md-trash">批量删除</Button>
                        <Button @click="exportData" icon="md-paper">导出</Button>
                        <Button @click="getDataList" icon="md-refresh">刷新</Button>
                        <circleLoading v-if="operationLoading"/>
                    </Row>
                    <Row>
                        <Alert show-icon>
                            已选择 <span class="select-count">{{selectCount}}</span> 项
                            <a class="select-clear" @click="clearSelectAll">清空</a>
                        </Alert>
                    </Row>
                    <Row>
                        <Table :loading="loading" border :columns="columns" :data="data" sortable="custom"
                               @on-sort-change="changeSort" @on-selection-change="showSelect" ref="table"></Table>
                    </Row>
                    <Row type="flex" justify="end" class="page">
                        <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize"
                              @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]"
                              size="small" show-total show-elevator show-sizer></Page>
                    </Row>
                </Card>
            </Col>
        </Row>
        <company-drawer ref="companyDrawer"></company-drawer>
    </div>
</template>
d
<script>
    import circleLoading from "../../my-components/circle-loading.vue";
    import studentDrawer from "./studentDrawer";
    import {companyList, delCompany, resetOtherPwd, setStatus} from "@/api/index";
    import CompanyDrawer from "./company-drawer";
    import Util from '@/libs/util';

    export default {
        name: "student-manage",
        components: {
            CompanyDrawer,
            circleLoading,
            studentDrawer
        },
        data() {
            return {
                loading: false, // 表单加载状态
                operationLoading: false,
                drop: false,
                selectCount: 0, // 多选计数
                selectList: [], // 多选数据
                dropDownContent: "展开",
                dropDownIcon: "ios-arrow-down",
                searchForm: {
                    pageNumber: 1, // 当前页数
                    pageSize: 10, // 页面大小
                    sort: "createTime", // 默认排序字段
                    order: "desc", // 默认排序方式
                    studentName: "",
                    mobile: "",
                    startDate: "",
                    endDate: ""
                },
                selectDate: null, //选择日期绑定modal
                columns: [
                    {
                        type: "selection",
                        width: 60,
                        align: "center"
                    },
                    {
                        type: "index",
                        width: 60,
                        align: "center"
                    },
                    {
                        title: "企业名称",
                        key: "compName",
                        width: 200,
                        sortable: true
                    }, {
                        title: "企业Logo",
                        key: "compLogo",
                        width: 100,
                        align: "center",
                        render: (h, params) => {
                            return h("Avatar", {
                                props: {
                                    src: params.row.compLogo
                                }
                            });
                        }
                    },
                    {
                        title: "是否禁用",
                        key: "status",
                        align: "center",
                        width: 120,
                        render: (h, params) => {
                            return h(
                                "i-switch",
                                {
                                    props: {
                                        value: params.row.status,
                                        size: "large",
                                        "true-value": 1,
                                        "false-value": 0
                                    },
                                    on: {
                                        "on-change": v => {
                                            this.setStatus(params.row, v);
                                        }
                                    }
                                },
                                [
                                    h("span", {slot: "open"}, "启用"),
                                    h("span", {slot: "close"}, "禁用")
                                ]
                            );
                        }
                    },
                    {
                        title: "联系方式",
                        key: "compTel",
                        width: 115,
                        sortable: true
                    },
                    {
                        title: "联系人",
                        key: "linkMan",
                        width: 115,
                        sortable: true
                    },
                    {
                        title: "企业邮箱",
                        key: "compEmail",
                        width: 180,
                        sortable: true
                    },
                    {
                        title: "企业地址",
                        key: "address",
                        width: 180,
                        sortable: true
                    },
                    {
                        title: "可添加员工数量",
                        key: "staffNum",
                        width: 150,
                        sortable: true
                    },
                    {
                        title: "VIP购买日期",
                        key: "createTime",
                        width: 220,
                        align: "center"
                    },
                    {
                        title: "VIP截止日期",
                        key: "expiryDate",
                        width: 220,
                        align: "center"
                    }, {
                        title: "操作",
                        key: "action",
                        width: 280,
                        align: "center",
                        fixed: "right",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row);
                                            }
                                        }
                                    },
                                    "编辑"
                                ), h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.resetOtherPwd(params.row);
                                            }
                                        }
                                    },
                                    "重置密码"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small"
                                        },
                                        on: {
                                            click: () => {
                                                this.remove(params.row);
                                            }
                                        }
                                    },
                                    "删除"
                                )
                            ]);
                        }
                    }],
                data: [], // 表单数据
                total: 0 // 表单数据总数
            }
        },
        methods: {
            init() {
                this.getDataList();
            },
            getDataList() {
                this.loading = true;
                companyList(this.searchForm).then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.data = res.data.rows;
                        this.total = res.data.total;
                    }
                });
            },
            setStatus(row, v) {
                let params = {
                    id: row.id,
                    status: v
                }
                setStatus(params).then(res => {
                    if (res.status === true) {
                        this.$Message.success(res.info);
                    }
                });
                ;
            },
            handleSearch() {
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.getDataList();
            },
            handleReset() {
                this.$refs.searchForm.resetFields();
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.selectDate = null;
                this.searchForm.startDate = "";
                this.searchForm.endDate = "";
                this.searchForm.compTel = "";
                this.searchForm.linkMan = "";
                this.searchForm.compName = "";
                // 重新加载数据
                this.getDataList();
            },
            dropDown() {
                if (this.drop) {
                    this.dropDownContent = "展开";
                    this.dropDownIcon = "ios-arrow-down";
                } else {
                    this.dropDownContent = "收起";
                    this.dropDownIcon = "ios-arrow-up";
                }
                this.drop = !this.drop;
            },
            selectDateRange(v) {
                if (v) {
                    this.searchForm.startDate = v[0];
                    this.searchForm.endDate = v[1];
                }
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getDataList();
                this.clearSelectAll();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getDataList();
            },
            changeSort(e) {
                this.searchForm.sort = e.key;
                this.searchForm.order = e.order;
                if (e.order === "normal") {
                    this.searchForm.order = "";
                }
                this.getDataList();
            },
            showSelect(e) {
                this.selectList = e;
                this.selectCount = e.length;
            },
            clearSelectAll() {
                this.$refs.table.selectAll(false);
            },
            add() {
                let query = {type: 0}
                this.$refs.companyDrawer.showDrawer(query);
            },
            edit(row) {
                let query = {type: 1, id: row.id};
                this.$refs.companyDrawer.showDrawer(query);
            },
            resetOtherPwd(row) {
                this.$Modal.confirm({
                    title: "重置密码",
                    content: "您确认要重置企业密码?",
                    onOk: () => {
                        resetOtherPwd({accountName: row.compTel}).then(res => {
                            if (res.status === true) {
                                this.$Message.success("重置成功");
                            }
                        });
                    }

                });
            },
            remove(row) {
                this.$Modal.confirm({
                    title: "确认删除",
                    content: "您确认要删除?",
                    onOk: () => {
                        delCompany(row.id).then(res => {
                            if (res.status === true) {
                                this.$Message.success("删除成功");
                                this.getDataList();
                            }
                        });
                    }
                });
            },
            delAll() {
                if (this.selectCount <= 0) {
                    this.$Message.warning("您还未选择要删除的数据");
                    return;
                }
                this.$Modal.confirm({
                    title: "确认删除",
                    content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
                    onOk: () => {
                        let ids = [];
                        this.selectList.forEach(function (e) {
                            ids.push(e.id);
                        });
                        delCompany(ids).then(res => {
                            if (res.status === true) {
                                this.$Message.success("删除成功");
                                this.clearSelectAll();
                                this.getDataList();
                            }
                        });
                    }
                });
            },
            exportData() {
                window.location.href = Util.initUrl("/base/common/companyExport", this.searchForm);
            }
        },
        mounted() {
            this.init();
        }
    }
</script>
